if (!customElements.get("rewards-header-button")) 
{
    customElements.define(
        "rewards-header-button",
        class RewardsHeaderButton extends HTMLElement {
            connectedCallback() {
                // Capture phase so we run before BON Loyalty's own click handler.
                this.addEventListener("click", this.closeMobileMenu, true);
            }
            disconnectedCallback() {
                this.removeEventListener("click", this.closeMobileMenu, true);
            }
            closeMobileMenu() {
                document
                .querySelector("header-drawer details[open] summary")
                ?.click();
            }
        },
    );
}